const selectors$8 = {
  flickityButton: '.flickity-prev-next-button',
  productLink: '[data-product-link]',
  slide: '[data-hover-slide]',
  slideTouch: '[data-hover-slide-touch]',
  slider: '[data-hover-slider]',
  recentlyViewed: 'recently-viewed',
  video: 'video',
  vimeo: '[data-host="vimeo"]',
  youtube: '[data-host="youtube"]',
};

class HoverImages extends HTMLElement {
  constructor() {
    super();

    this.flkty = null;
    this.slider = this.querySelector(selectors$8.slider);
    this.handleScroll = this.handleScroll.bind(this);
    this.recentlyViewed = this.closest(selectors$8.recentlyViewed);
    this.hovered = false;

    this.mouseEnterEvent = () => this.mouseEnterActions();
    this.mouseLeaveEvent = () => this.mouseLeaveActions();

    this.addEventListener('mouseenter', this.mouseEnterEvent);
    this.addEventListener('mouseleave', this.mouseLeaveEvent);
  }

  connectedCallback() {
    this.addArrowClickHandler();

    if (this.recentlyViewed) {
      if (!this.recentlyViewed.classList.contains('hidden')) {
        this.initBasedOnDevice();
      } else {
        this.onRecentlyViewedLoaded = () => this.initBasedOnDevice();
        this.recentlyViewed.addEventListener('theme:recently-viewed:loaded', this.onRecentlyViewedLoaded);
      }
    } else {
      this.initBasedOnDevice();
    }
  }

  disconnectedCallback() {
    if (this.flkty) {
      this.flkty.options.watchCSS = false;
      this.flkty.destroy();
      this.flkty = null;
    }

    if (this.recentlyViewed && this.onRecentlyViewedLoaded) {
      this.recentlyViewed.removeEventListener('theme:recently-viewed:loaded', this.onRecentlyViewedLoaded);
    }

    this.removeEventListener('mouseenter', this.mouseEnterEvent);
    this.removeEventListener('mouseleave', this.mouseLeaveEvent);
  }

  initBasedOnDevice() {
    if (window.theme.touch) {
      this.initTouch();
    } else {
      this.initFlickity();
    }
  }

  addArrowClickHandler() {
    const productLink = this.closest(selectors$8.productLink);
    if (productLink) {
      productLink.addEventListener('click', (e) => {
        if (e.target.matches(selectors$8.flickityButton)) {
          e.preventDefault();
        }
      });
    }
  }

  initTouch() {
    this.style.setProperty('--slides-count', this.querySelectorAll(selectors$8.slideTouch).length);
    this.slider.addEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    const slideIndex = this.slider.scrollLeft / this.slider.clientWidth;
    this.style.setProperty('--slider-index', slideIndex);
  }

  initFlickity() {
    if (this.flkty || !this.slider || this.slider.classList.contains('flickity-enabled') || this.querySelectorAll(selectors$8.slide).length < 2) return;

    this.flkty = new window.theme.Flickity(this.slider, {
      cellSelector: selectors$8.slide,
      contain: true,
      wrapAround: true,
      watchCSS: true,
      autoPlay: false,
      draggable: false,
      pageDots: false,
      prevNextButtons: true,
    });

    this.flkty.pausePlayer();

    this.addEventListener('mouseenter', () => {
      this.flkty.unpausePlayer();
    });

    this.addEventListener('mouseleave', () => {
      this.flkty.pausePlayer();
    });
  }

  mouseEnterActions() {
    this.hovered = true;

    this.videoActions();
  }

  mouseLeaveActions() {
    this.hovered = false;

    this.videoActions();
  }

  videoActions() {
    const youtube = this.querySelector(selectors$8.youtube);
    const vimeo = this.querySelector(selectors$8.vimeo);
    const mediaExternal = youtube || vimeo;
    const mediaNative = this.querySelector(selectors$8.video);

    if (mediaExternal) {
      let action = this.hovered ? 'playVideo' : 'pauseVideo';
      let string = `{"event":"command","func":"${action}","args":""}`;

      if (vimeo) {
        action = this.hovered ? 'play' : 'pause';
        string = `{"method":"${action}"}`;
      }

      mediaExternal.contentWindow.postMessage(string, '*');

      mediaExternal.addEventListener('load', (e) => {
        // Call videoActions() again when iframe is loaded to prevent autoplay being triggered if it loads after the "mouseleave" event
        this.videoActions();
      });
    } else if (mediaNative) {
      if (this.hovered) {
        mediaNative.play();
      } else {
        mediaNative.pause();
      }
    }
  }
}

if (!customElements.get('hover-images')) {
  customElements.define('hover-images', HoverImages);
}
